import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnexoRepository } from '@app/data/anexo/anexo.repository';
import { MedicaoRepository } from '@app/data/medicoes/medicao.repository';
import { modal } from '@app/shared/alerts/modal/modal.alert';
import { FileData } from '@app/shared/components/anexos/file/file.component';
import { currencyBRL } from '@app/shared/formatters';
import { AnexosComponent, AnexosOptions } from '@components/anexos/anexos.component';
import { Campo, FormComponent } from '@components/form/form.component';

@Component({
  selector: 'app-detalhes-medicao',
  templateUrl: './detalhes-medicao.component.html',
  styleUrls: ['./detalhes-medicao.component.scss'],
})
export class DetalhesMedicaoComponent implements AfterContentChecked {
  protected loading: boolean = false;

  protected camposDadosDetalhes: Campo[] = [
    {
      name: '',
      label: 'Medição',
      type: 'separator',
    },
    {
      name: 'cliente.pessoa.razaoSocial',
      label: 'Cliente',
      type: 'text',
      disabled: true,
      width: '100%',
    },
    {
      name: 'fatura.numeroDocumento',
      label: 'Nº Documento',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fatura.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'dataEmissao',
      label: 'Data Emissão',
      type: 'date',
      disabled: true,
      width: '50%',
    },
    {
      name: 'dataVencimentoBase',
      label: 'Data Vencimento',
      type: 'date',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fatura.contrato.veiculo.placa',
      label: 'Placa',
      type: 'text',
      disabled: true,
      width: '40%',
    },
    {
      name: 'fatura.contrato.veiculo.modelo.descricao',
      label: 'Modelo',
      type: 'text',
      disabled: true,
      width: '60%',
    },

    {
      name: '',
      label: 'Valores da Medição',
      type: 'separator',
    },
    {
      name: 'valores',
      label: 'Itens',
      type: 'table',
      disabled: true,
      width: '100%',
      tableOptions: {
        items: [],
        colunas: [
          {
            name: 'tipoValor.descricao',
            label: 'Tipo Valor',
          },
          {
            name: 'valor',
            label: 'Valor',
            format: currencyBRL,
          },
        ],
      },
    },
    {
      name: '',
      label: 'Detalhes da Medicão',
      type: 'separator',
    },
    {
      name: 'fatura.corpo',
      label: 'Detalhes da Medição',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
  ];

  protected anexosOptions: AnexosOptions = {
    disableUpload: false,
  };

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DetalhesMedicaoComponent>,
    private changeDetector: ChangeDetectorRef,
    private anexoRepository: AnexoRepository,
    private MedicaoRepository: MedicaoRepository,
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.anexoRepository.getAnexos('Medicoes', this.data.codigoMedicao).subscribe((data: any) => {
      if (this.anexos) {
        this.anexos.setSentFiles(data);
      }
    });
  }

  protected imprimirMedicao() {}

  protected exportarMedicao() {}

  protected onClose() {
    this.dialogRef.close(false);
  }

  protected onSubmit(anexos: FileData[]) {
    if (anexos.length > 0)
      this.anexoRepository.postAnexos('Medicoes', this.data.codigoMedicao, anexos).subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: () => {
          modal.fire({
            icon: 'error',
            title: 'Erro ao salvar anexos',
            html: 'Tente novamente mais tarde por meio dos detalhes das medições',
          });

          this.dialogRef.close(false);
        },
      });
  }
}
